import axios from "axios";

const axiosInstance = ({ requiresAuth = false } = {}) => {
    const options = {
        baseURL: process.env.VUE_APP_API_BASE_URL,
        headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
        },
    };

    if (requiresAuth) {
        const token = localStorage.getItem("token");
        if (token) {
            options.headers.Authorization = `Bearer ${token}`;
        }
    }

    const instance = axios.create(options);

    // Add response interceptor to handle authentication errors
    instance.interceptors.response.use(
        (response) => {
            // If the response is successful, just return it
            return response.data;
        },
        (error) => {
            // Check if the error is due to authentication (401 or 403)
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {

                // Clear authentication data immediately
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                sessionStorage.clear();

                // Only redirect if not already on login page
                if (window.location.pathname !== '/login') {

                    // Update store state if possible
                    import('@/state/store').then(({ default: store }) => {
                        store.dispatch('auth/forceLogOut');
                    }).catch(() => {
                        // Store update failed - silently continue
                    });

                    // Show notification immediately (non-blocking)
                    import('sweetalert2').then(({ default: Swal }) => {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 4000,
                            timerProgressBar: true,
                            icon: 'warning'
                        });

                        Toast.fire({
                            title: 'Session Expired',
                            text: 'Your session has expired. Please log in again.'
                        });
                    }).catch(() => {
                        // Notification failed - silently continue
                    });

                    // Redirect immediately without waiting
                    window.location.replace('/login');
                } else {
                    // Already on login page - no action needed
                }
            }

            // Return the error for further handling
            return Promise.reject(error);
        }
    );

    return instance;
};

export default axiosInstance;